//BottomBar.js
import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { StyleSheet, css } from "aphrodite/no-important";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import Warning from "@material-ui/icons/Warning";
import Server from "components/Server";
import { ClipLoader } from "react-spinners";
import Button from "@material-ui/core/Button";
import Snackbar from "components/Snackbar";
import FullPageLoader from "components/FullPageLoader";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Close from "@material-ui/icons/Close";
import Sort from "@material-ui/icons/Sort";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { orderBy } from "lodash";
import Grid from "@material-ui/core/Grid";
import Moon from "../packages/Moon";
import Typography from "@material-ui/core/Typography";

const styles = {
	BottomBar: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end",
		height: "100%",
		width: "100%",
		backgroundColor: "white",
		position: "relative",
		flexWrap: "nowrap"
	},
	paginationContainer: {
		height: "50px",
		position: "relative",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "nowrap",
		padding: "0px 15px"
	},
	selectedItemsContainer: {
		height: "70px",
		width: "100%",
		position: "absolute",
		boxSizing: "border-box",
		backgroundColor: "ghostwhite",
		bottom: "50px",
		left: "0px",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "nowrap",
		padding: "0px 15px"
	},
	pagination: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "nowrap",
		position: "relative"
	},
	pageInput: {
		textAlign: "center"
	},
	pageInputText: {
		fontSize: "17px"
	},
	seperator: {
		textAlign: "center",
		width: "20px",
		height: "100%",
		lineHeight: "50px",
		cursor: "default",
		userSelect: "none"
	},
	maxPage: {
		textAlign: "center",
		width: "50px",
		height: "100%",
		lineHeight: "50px",
		cursor: "default"
	},
	selectedItemsCount: {
		height: "100%",
		lineHeight: "50px",
		cursor: "default",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	unUserSelect: {
		userSelect: "none"
	},
	pageLoading: {
		position: "absolute",
		right: "6px",
		top: "6px"
	},
	saveAndPublish: {
		position: "relative"
	},
	selectedItemRightContainer: {
		width: "140px",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "nowrap"
	},
	actionButtons: {
		flexDirection: "row",
		justifyContent: "flex-start",
		flex: 1
	},
	sortByTypeBox: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxSizing: "box",
		width: "100%",
		hegiht: "100%"
	},
	reversePositionsOnSaveWarning: {
		width: "100%",
		height: "40px",
		display: "flex",
		alignItems: "center",
		boxSizing: "box",
		backgroundColor: "#e74c3c",
		color: "white",
		borderRadius: "3px",
		marginTop: "15px"
	}
};

const classes = StyleSheet.create({
	page: {
		width: "20px"
	},
	moveToTextField: {
		marginLeft: "10px",
		marginTop: "7px",
		width: "50px"
	},
	pageInputButton: {
		height: "100%"
	},
	marginRight: {
		marginRight: "7px"
	},
	sortByTypeButton: {
		display: "flex",
		minWidth: "125px",
		maxWidth: "100%",
		color: "#333",
		justifyContent: "center",
		alignItems: "center",
        padding: "0px",
        margin: "10px",
		borderRadius: "3px",
		height: "42px",
		backgroundColor: "#f1f1f1",
		cursor: "pointer"
	},
	sortByTypeButtonSelected: {
		backgroundColor: "#3f51b5",
		color: "white",
		":hover": {
			backgroundColor: "#303f9f"
		}
	}
});

const focusInput = input => {
	if (input) {
		setTimeout(() => {
			input.focus();
		}, 100);
	}
};

class BottomBar extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			currentPage: 1,
			saveAndPublishDialog: false,
			paginationDialog: false,
			pageNumberInputValue: null,
			moveToInputValue: "",
			selectedItemsLogic: 1,
			showSelectedItems: false,
			anchorEl: null,
			sortByDialog: false,
			sortByType: "system",
			orderByType: "aes",
            reversePositionsOnSave: Moon.use(),
            fileInput: "",
            skuHeaderName: this.fromLocalStorage("skuHeaderName"),
            skuHeaderNameError: false,
            positionHeaderName: this.fromLocalStorage("positionHeaderName"),
            positionHeaderNameError: false
		};

		// for internal use
		this.setTimeout = null;
		this.setTimeoutDelay = 250;
		this.showSelectedItemsTimeout = null;

		this.applyOnClick = this.applyOnClick.bind(this);
		this.clearSelectedItems = this.clearSelectedItems.bind(this);
		this.moveToInputOnChange = this.moveToInputOnChange.bind(this);
		this.onChangeSelectedItemsLogic = this.onChangeSelectedItemsLogic.bind(
			this
		);
		this.setSortByType = this.setSortByType.bind(this);
		this.sortByDialogOpen = this.sortByDialogOpen.bind(this);
		this.sortByDialogClose = this.sortByDialogClose.bind(this);
        this.SortByLogic = this.SortByLogic.bind(this);
        this.SortByFileDone = this.SortByFileDone.bind(this);
    }
    
    fromLocalStorage(itemName) {
        const item = localStorage.getItem(itemName);
		if (item) return item;
		return "";
    }

	componentWillMount() {
		Moon.addStar(this);
	}

	componentDidMount() {}

	inputProps = {
		onKeyPress: this.handleEnterKeyPress.bind(this)
	};

	handleEnterKeyPress(e) {
		if (e.key === "Enter") {
			if (this.props.selectedItems.length === 0)
				this.goToPageNumberByInput();
			else this.applyOnClick();
		}
	}

	changePageBy(num) {
		let newPage = this.state.currentPage + num;
		if (newPage < 1 || newPage > this.state.maxPage) return;
		clearTimeout(this.setTimeout);
		this.setTimeout = setTimeout(() => {
			this.props.changePage(newPage);
		}, this.setTimeoutDelay);
		this.setState({ currentPage: newPage, pageNumberInputValue: null });
		setTimeout(() => {
			ReactDOM.findDOMNode(this.refs.pageInputButton).blur();
		}, 260);
	}

	goToPageNumberByInput() {
		if (this.state.pageNumberInputValue === null) return;
		let newPage = this.state.pageNumberInputValue - this.state.currentPage;
		this.paginationDialogClose();
		this.changePageBy(newPage);
	}

	pageInputOnChange(event) {
		let value = event.target.value;
		if (value != null && value != "") {
			value = parseInt(value);
			if (value < 1) value = 1;
			else if (value > this.props.maxPage) {
				value = this.props.maxPage;
			}
		}
		this.setState({ pageNumberInputValue: value });
	}

	saveAndPublish() {
		this.saveAndPublishDialogClose();
		FullPageLoader.open("Save & Publish", "This may take a while");
		let products = {};
		if (this.state.reversePositionsOnSave != true)
			this.props.products.forEach(e => {
				products[e.id] = e.sort;
			});
		else {
			let productsOrderByPosition = this.props.products.map((e, i) => {
				return Object.assign({}, e);
			});
			productsOrderByPosition = orderBy(
				productsOrderByPosition,
				"sort",
				"asc"
			);
			let length = productsOrderByPosition.length;
			let sort = productsOrderByPosition[length - 1].sort;
			productsOrderByPosition.forEach(e => {
				products[e.id] = sort;
				sort = sort - 1;
			});
		}
		console.log(products);
		let data = {
			products: JSON.stringify(products),
			category_id: this.props.categoryId,
			category_url: this.props.categoryUrl,
			category_type: this.props.categoryType,
			maxPage: this.props.maxPage
		};
		Server.post("/webpage/save", data, this.saveAndPublishDone.bind(this));
	}

	saveAndPublishDone(res) {
		// show more nicly message
		console.log(res);
		FullPageLoader.close();
		if (res.data.response) Snackbar.info("Done with save & publish!");
		else Snackbar.info("Error on save & publish :-(");
	}

	renderPaginationBottomBar() {
		return (
			<div style={styles.paginationContainer}>
				{this.renderPagination()}
				{this.renderActionButtons()}
				{this.renderSaveAndPublish()}
			</div>
		);
	}

	saveAndPublishDialogClose() {
		this.setState({ saveAndPublishDialog: false });
	}

	saveAndPublishDialogOpen() {
		this.setState({ saveAndPublishDialog: true });
	}

	paginationDialogClose() {
		this.setState({ paginationDialog: false });
	}

	paginationDialogOpen() {
		this.setState({ paginationDialog: true });
	}

	onChangeSelectedItemsLogic = event => {
		let selected = event.target.value;
		this.setState({
			selectedItemsLogic: selected,
			moveToInputValue: ""
		});
	};

	moveToInputOnChange = event => {
		let value = event;
		if (event.target != null) value = event.target.value;
		if (value != null && value != "") {
			value = parseInt(value);
			if (this.state.selectedItemsLogic > 1) {
				if (value >= this.props.maxPage) value = this.props.maxPage;
				else if (value < 1) value = 1;
			} else {
				const selectedItemsLength = this.props.selectedItems.length - 1;
				if (value + selectedItemsLength >= this.props.products.length)
					value =
						this.props.products.length - selectedItemsLength - 1;
				else if (value < 0) value = 0;
			}
		}
		this.setState({ moveToInputValue: value });
	};

	applyOnClick = () => {
		let value = this.state.moveToInputValue;
		let logic = this.state.selectedItemsLogic;

		if (value == null || value === "" || value < 0) {
			Snackbar.error("Input value can't be empty!");
			return;
		}
		switch (logic) {
			case 1: {
				this.moveToPosition(value);
				break;
			}
			case 2: {
				this.moveToFirstOnPage(value);
				break;
			}
			case 3: {
				this.moveToLastOnPage(value);
				break;
			}
			default: {
				break;
			}
		}
	};

	moveToPosition(value) {
		const position = parseInt(value);
		const selectedItemsLength = this.props.selectedItems.length;
		let needToOverride = false;
		let OutOfRangeSort = 100000;
		let newProductsSort = this.props.products.map((e, i) => {
			return Object.assign({}, e);
		});
		// push all selected items to the end
		this.props.selectedItems.forEach((elem, index) => {
			newProductsSort[elem.key].sort = OutOfRangeSort + index;
		});
		// order items by sort..
		newProductsSort = orderBy(newProductsSort, "sort", "asc");
		// re-sort products
		let sort = 0;
		newProductsSort.forEach((elem, index) => {
			if (sort == position) sort = sort + selectedItemsLength;
			if (elem.sort < OutOfRangeSort) {
				elem.sort = sort;
				sort = sort + 1;
			}
		});
		// order items by key..
		newProductsSort = orderBy(newProductsSort, "key", "asc");
		// sort selected items on selected position
		this.props.selectedItems.forEach((elem, index) => {
			newProductsSort[elem.key].sort = position + index;
		});

		// set the new products sort..
		this.applyNewProductsSort(newProductsSort);
	}

	moveToFirstOnPage(value) {
		const page = parseInt(value) - 1;
		const position = page * this.props.productsPerPage;
		this.moveToPosition(position);
	}

	moveToLastOnPage(value) {
		const page = parseInt(value) - 1;
		const selectedItemsLength = this.props.selectedItems.length - 1;
		const lastSortItemOnPage =
			page == this.props.maxPage - 1
				? this.props.products.length - 1
				: page * this.props.productsPerPage +
				  this.props.productsPerPage -
				  1;
		const position = lastSortItemOnPage - selectedItemsLength;
		this.moveToPosition(position);
	}

	SortByLogic() {
        if (this.state.sortByType !== 'file')
            this.SortByVariable();
        else
            this.SortByFile();
    }
    
    SortByVariable() {
        let newProductsSort = this.props.products.map((e, i) => {
			return Object.assign({}, e);
		});
		let type = this.GetSortByType();
		newProductsSort = orderBy(
			newProductsSort,
			type,
			this.state.orderByType
		);
		newProductsSort.forEach((elem, index) => {
			elem.sort = index;
		});
		this.applyNewProductsSort(newProductsSort);
    }

	GetSortByType() {
		if (this.state.sortByType == "system") return "key";
		if (this.state.sortByType == "stock") return "qty";
		if (this.state.sortByType == "price") return "sortby_price";
    }
    
    SortByFile() {
        let fileInput = this.state.fileInput;
        let skuHeaderName = this.state.skuHeaderName;
        let positionHeaderName = this.state.positionHeaderName;
        let formData = new FormData();
        formData.append('file', fileInput);
        formData.append('sku_header_name', skuHeaderName);
        formData.append('position_header_name', positionHeaderName);
        Server.submit("/utils/sortbyfile", formData, this.SortByFileDone);
    }

    SortByFileDone(res) {
        const sort = res.data.sort;
        let newProductsSort = this.props.products.map((e, i) => {
			return Object.assign({}, e);
        });
        newProductsSort = orderBy(
			newProductsSort,
			"sort",
			"aes"
		);
        newProductsSort.forEach((elem, index) => {
            if (elem.sku in sort)
                elem.sort = sort[elem.sku];
            else 
                elem.sort = -1;
        });
        let max = newProductsSort.reduce((max, p) => p.sort > max ? p.sort : max, -1);
        newProductsSort.forEach((elem, index) => {
            if (elem.sort === -1) {
                max++;
                elem.sort = max;
            }
        });
        this.applyNewProductsSort(newProductsSort);
    }

	applyNewProductsSort(newProductsSort) {
		this.props.setProducts(newProductsSort);
		setTimeout(() => {
			this.props.clearSelectedItems();
		}, 100);
	}

	sortByDialogOpen() {
		this.setState({ sortByDialog: true });
	}

	sortByDialogClose() {
		this.setState({ sortByDialog: false });
	}

	orderByType = event => {
		this.setState({ orderByType: event.target.value });
	};

	setSortByType(type) {
		let order = "aes";
		if (type == "stock") order = "desc";
		this.setState({ sortByType: type, orderByType: order });
	}

	clearSelectedItems() {
		this.props.clearSelectedItems();
	}

	renderSortByButton() {
		return (
			<React.Fragment>
				<Button
					disabled={this.props.pageLoading}
					aria-owns={this.state.anchorEl ? "sortby-menu" : undefined}
					aria-haspopup="true"
					onClick={this.sortByDialogOpen}
				>
					<Sort className={css(classes.marginRight)} />
					{"Sort By"}
				</Button>
				<Dialog
					open={this.state.sortByDialog}
					onClose={this.sortByDialogClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">Sort by</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description" />
						<Grid container spacing={2}>
							<Grid item xs={3}>
								<Button
									classes={{
										root: css(
											classes.sortByTypeButton,
											this.state.sortByType == "system"
												? classes.sortByTypeButtonSelected
												: null
										)
									}}
									onClick={() => this.setSortByType("system")}
								>
									<div style={styles.sortByTypeBox}>
										System
									</div>
								</Button>
							</Grid>
							<Grid item xs={3}>
								<Button
									classes={{
										root: css(
											classes.sortByTypeButton,
											this.state.sortByType == "stock"
												? classes.sortByTypeButtonSelected
												: null
										)
									}}
									onClick={() => this.setSortByType("stock")}
								>
									<div style={styles.sortByTypeBox}>
										Stock
									</div>
								</Button>
							</Grid>
							<Grid item xs={3}>
								<Button
									classes={{
										root: css(
											classes.sortByTypeButton,
											this.state.sortByType == "price"
												? classes.sortByTypeButtonSelected
												: null
										)
									}}
									onClick={() => this.setSortByType("price")}
								>
									<div style={styles.sortByTypeBox}>
										Price
									</div>
								</Button>
							</Grid>
                            <Grid item xs={3}>
								<Button
									classes={{
										root: css(
											classes.sortByTypeButton,
											this.state.sortByType == "file"
												? classes.sortByTypeButtonSelected
												: null
										)
									}}
									onClick={() => this.setSortByType("file")}
								>
									<div style={styles.sortByTypeBox}>
										File
									</div>
								</Button>
							</Grid>
						</Grid>
						<Grid container spacing={2}>
                            {this.state.sortByType != 'file' &&
                                <Grid item xs={8}>
								<span style={{ marginRight: "10px" }}>
									Order by
								</span>
								<Select
									value={this.state.orderByType}
									onChange={this.orderByType}
									displayEmpty
									name="orderByType"
								>
									<MenuItem value={"aes"}>AES</MenuItem>
									<MenuItem value={"desc"}>DESC</MenuItem>
								</Select>
							</Grid>
                            }
                            {this.state.sortByType == 'file' && <Grid item xs={12}>
                                
								<span style={{ marginRight: "10px" }}>
									Select file: <b>{this.state.fileInput != null ? this.state.fileInput.name : ""}</b>
								</span>
                                <input
                                    name="fileInput"
                                    accept=".xlsx, .xls"
                                    id="file-input"
                                    type="file"
                                    hidden
                                    value={undefined}
                                    onChange={this.fileInputOnChange}
                                />
								<label htmlFor="file-input">
                                    <Button variant="outlined" component="span">
                                        Browse
                                    </Button>
                                </label>
                                <p/>
                                <span style={{ marginRight: "10px" }}>
									Headers name:
								</span>
                                <Grid container spacing={2}>
                                <Grid item xs={4}>
                                        <TextField
                                            required
                                            type={"text"}
                                            label={"SKU header name"}
                                            defaultValue={this.state.skuHeaderName}
                                            margin="normal"
                                            fullWidth
                                            error={this.state.skuHeaderNameError}
                                            helperText={
                                                this.state.skuHeaderNameError
                                                    ? "Required field can't be empty!"
                                                    : null
                                            }
                                            onChange={this.handleInputOnChange("skuHeaderName", true)}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            required
                                            type={"text"}
                                            label={"Position header name"}
                                            defaultValue={this.state.positionHeaderName}
                                            margin="normal"
                                            fullWidth
                                            error={this.state.positionHeaderNameError}
                                            helperText={
                                                this.state.positionHeaderNameError
                                                    ? "Required field can't be empty!"
                                                    : null
                                            }
                                            onChange={this.handleInputOnChange("positionHeaderName", true)}
                                        />
                                    </Grid>
                                </Grid>
							</Grid>
                            }
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.sortByDialogClose}
							color="primary"
						>
							Not now
						</Button>
						<Button
							onClick={() => {
								this.sortByDialogClose();
								setTimeout(() => {
									this.SortByLogic();
								}, 25);
							}}
							color="secondary"
                            variant="contained"
                            disabled={this.validateSortByType()}
						>
							Sort by {this.state.sortByType}
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		);
    }

    fileInputOnChange = e => {
        this.setState({"fileInput": e.target.files[0]});
    }

    handleInputOnChange = (name, save = false) => event => {
        const val = event.target.value;
		this.setState({
			[name]: val
        },
        () => {
            if (save)
                localStorage.setItem(name, val);
        });
    };
    
    validateSortByType = () => {
        if (this.state.sortByType !== "file")
            return false;
        
        if (this.state.fileInput != null && this.state.fileInput != ""
            && this.state.skuHeaderName != null && this.state.skuHeaderName.length > 0
            && this.state.positionHeaderName != null && this.state.positionHeaderName.length > 0)
            return false;
        return true;
    }

	renderActionButtons() {
		return (
			<div style={styles.actionButtons}>{this.renderSortByButton()}</div>
		);
	}

	renderSaveAndPublish() {
		let elem = this;
		return (
			<div style={styles.saveAndPublish}>
				<Button
					variant="contained"
					color="primary"
					onClick={this.saveAndPublishDialogOpen.bind(this)}
					disabled={
						this.props.pageLoading &&
						this.state.reversePositionsOnSave
					}
				>
					{"Save & Publish"}
				</Button>
				<Dialog
					open={this.state.saveAndPublishDialog}
					onClose={this.saveAndPublishDialogClose.bind(this)}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{"Save & Publish - Are You Sure?"}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							This operation will save all positions changes you
							made on this category. Your ecommerce system will be
							update immediately!
							{this.state.reversePositionsOnSave && (
								<div
									style={styles.reversePositionsOnSaveWarning}
								>
									<span
										style={{
											margin: "15px",
											fontSize: "4px"
										}}
									>
										<Warning />
									</span>{" "}
									Reverse position is activeted!
								</div>
							)}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.saveAndPublishDialogClose.bind(this)}
							color="primary"
						>
							Not now
						</Button>
						<Button
							onClick={this.saveAndPublish.bind(this)}
							color="secondary"
							variant="contained"
						>
							{"Save & Publish"}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	renderPagination() {
		return (
			<div style={styles.pagination}>
				<Button
					color="primary"
					onClick={() => this.changePageBy(-1)}
					disabled={this.state.currentPage == 1}
				>
					{this.props.flatItems ? (
						<KeyboardArrowUp />
					) : (
						<NavigateBeforeIcon />
					)}
				</Button>
				{this.renderPageInput()}
				<Button
					color="primary"
					onClick={() => this.changePageBy(1)}
					disabled={this.state.currentPage == this.props.maxPage}
				>
					{this.props.flatItems ? (
						<KeyboardArrowDown />
					) : (
						<NavigateNextIcon />
					)}
				</Button>
				<div style={styles.seperator}> / </div>
				{this.renderMaxPage()}
				{this.props.pageLoading && (
					<div style={styles.pageLoading}>
						<ClipLoader
							color={"#123abc"}
							loading={true}
							size={37}
						/>
					</div>
				)}
			</div>
		);
	}

	renderPageInput() {
		return (
			<div style={{ ...styles.pageInput, ...styles.unUserSelect }}>
				<Button
					classes={{ root: css(classes.pageInputButton) }}
					color="primary"
					ref={"pageInputButton"}
					onClick={this.paginationDialogOpen.bind(this)}
					disabled={this.props.maxPage === 1}
				>
					<div style={styles.pageInputText}>
						{this.state.currentPage}
					</div>
				</Button>
				<Dialog
					open={this.state.paginationDialog}
					onClose={this.paginationDialogClose.bind(this)}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{"Page selector"}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							Which page do you want to go? [1-
							{this.props.maxPage}]
						</DialogContentText>
						<TextField
							margin="dense"
							id="pageNumberInput"
							label="Page number"
							type="number"
							fullWidth
							inputRef={focusInput}
							value={this.state.pageNumberInputValue}
							onChange={this.pageInputOnChange.bind(this)}
							inputProps={this.inputProps}
						/>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.paginationDialogClose.bind(this)}
							color="primary"
						>
							Not now
						</Button>
						<Button
							onClick={this.goToPageNumberByInput.bind(this)}
							color="secondary"
							variant="contained"
							autoFocus
						>
							Go
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	renderMaxPage() {
		return (
			<div style={{ ...styles.maxPage, ...styles.unUserSelect }}>
				{this.props.maxPage}
			</div>
		);
	}

	renderSelectedItemBottomBar() {
		if (this.state.showSelectedItems == false) return null;
		return (
			<div style={styles.selectedItemsContainer}>
				<div
					style={{
						...styles.selectedItemsCount,
						...styles.unUserSelect
					}}
				>
					{this.props.selectedItems.length}
					{"  "}
					{this.props.selectedItems.length == 1
						? "Item"
						: "Items"}{" "}
					selected
				</div>
				<div>
					<Button color="primary">
						<div style={{ margin: "0px 10px 0px 0px" }}>
							Move to:
						</div>
						<Select
							value={this.state.selectedItemsLogic}
							onChange={this.onChangeSelectedItemsLogic}
							displayEmpty
							name="Logic"
						>
							<MenuItem value={1}>POSITION</MenuItem>
							<MenuItem value={2}>FIRST ON PAGE</MenuItem>
							<MenuItem value={3}>LAST ON PAGE</MenuItem>
						</Select>
						<TextField
							classes={{ root: css(classes.moveToTextField) }}
							margin="dense"
							id="moveTo"
							label=""
							type="number"
							inputRef={focusInput}
							onChange={this.moveToInputOnChange}
							value={this.state.moveToInputValue}
							inputProps={this.inputProps}
						/>
					</Button>
				</div>
				<div style={styles.selectedItemRightContainer}>
					<Button
						variant="contained"
						color="primary"
						onClick={this.applyOnClick}
					>
						{"Apply"}
					</Button>
					<Button color="primary" onClick={this.clearSelectedItems}>
						<Close />
					</Button>
				</div>
			</div>
		);
	}

	UNSAFE_componentWillUpdate(nextProps, nextState) {
		if (nextProps.selectedItems.length != this.props.selectedItems.length) {
			if (nextProps.selectedItems.length == 0) {
				this.state.moveToInputValue = "";
				this.showSelectedItemsTimeout = setTimeout(() => {
					this.setState({ showSelectedItems: false });
				}, 300);
			} else {
				clearTimeout(this.showSelectedItemsTimeout);
				this.state.showSelectedItems = true;
			}
			const moveToInputValue = this.state.moveToInputValue;
			if (moveToInputValue != null && moveToInputValue != "")
				this.moveToInputOnChange(moveToInputValue);
		}
	}

	render() {
		return (
			<div style={this.props.style}>
				<div style={styles.BottomBar}>
					{this.renderSelectedItemBottomBar()}
					{this.renderPaginationBottomBar()}
				</div>
			</div>
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.currentPage != this.props.currentPage &&
			this.props.currentPage != this.state.currentPage
		)
			this.setState({ currentPage: this.props.currentPage });
	}
}
export default BottomBar;
